import { z } from "zod";
export const uuidSchema = z.string().uuid();
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email("Ungültige E-Mail-Adresse")
    .max(254);
export const passwordSchema = z
    .string()
    .min(10, "Passwort muss mindestens 10 Zeichen lang sein")
    .max(128, "Passwort darf höchstens 128 Zeichen lang sein");
export const nameSchema = z
    .string()
    .trim()
    .min(1, "Pflichtfeld")
    .max(80);
export const mobilePhoneSchema = z
    .string()
    .trim()
    .min(5)
    .max(40)
    .regex(/^[+0-9 ()\-/.]+$/, "Ungültige Telefonnummer")
    .optional()
    .nullable();
export const isoDateTimeSchema = z
    .string()
    .datetime({ offset: true, message: "Ungültiges ISO-Datum" });
export const paginationSchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=common.js.map